<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="section_1 flex-col">
        <div class="block_3 flex-col">
          <div class="group_3 flex-row">
            <div class="text-group_1 flex-col">
              <span class="text_13">科研保障</span>
              <span class="text_14">党建、行政、离退休服务和职工集体活动共同构成研究所科研运行的重要保障。</span>
            </div>
          </div>
          <div class="text-wrapper_2">
            <span class="text_15">
              <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
              &nbsp;&gt;&nbsp;
              <router-link to="/lanhu_keyanbaozhang" style="color: inherit; text-decoration: none;">科研保障</router-link>
              &nbsp;&gt;&nbsp;
            </span>
            <span class="text_16">科研保障</span>
          </div>
          <div class="group_4 flex-col"></div>
          <div class="group_5 flex-row justify-between">
            <div class="sidebar-slot">
              <SidebarAccordion
                :sections="sidebarSections"
                active-section-id="research-support"
                active-item-id="research-support"
              />
            </div>
            <div class="group_7 flex-col content-slot">
              <div class="text-wrapper_4 flex-col"><span class="text_19">科研保障</span></div>

              <div class="content-shell">
                <section class="overview-card">
                  <p class="eyebrow">栏目总览</p>
                  <h2 class="overview-title">支撑科研运行的组织与服务体系</h2>
                  <p class="overview-text">
                    研究所围绕科研运行、组织建设、行政管理、离退休服务和职工集体活动，持续建设稳定高效的综合保障体系。
                  </p>
                  <p class="overview-text">
                    本栏目将原纪念册中的相关照片和说明文字拆解重排，以图文卡片形式呈现各项保障工作的历史片段。
                  </p>
                </section>

                <section class="entry-section">
                  <div class="entry-section__header">
                    <div>
                      <p class="eyebrow">栏目入口</p>
                      <h2 class="overview-title overview-title--compact">科研保障各子页</h2>
                    </div>
                  </div>

                  <div class="entry-grid">
                    <router-link
                      v-for="item in supportItems"
                      :key="item.title"
                      :to="item.route"
                      class="entry-card"
                    >
                      <div class="entry-card__image">
                        <img :src="item.image" :alt="item.title" loading="lazy" />
                      </div>
                      <div class="entry-card__body">
                        <p class="entry-card__tag">{{ item.tag }}</p>
                        <h3 class="entry-card__title">{{ item.title }}</h3>
                        <p class="entry-card__desc">{{ item.description }}</p>
                      </div>
                    </router-link>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter
        :notch-width="704"
        notch-left="calc((100vw - 1300px) / 2 + 445px)"
      />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import SidebarAccordion from '@/components/SidebarAccordion.vue';
import { createSidebarSections } from '@/config/secondarySidebar';

export default {
  name: 'LanhuKeyanbaozhang',
  components: {
    SiteHeader,
    SiteFooter,
    SidebarAccordion
  },
  data() {
    return {
      sidebarSections: createSidebarSections({
        activeSectionId: 'research-support',
        activeItemId: 'research-support'
      }),
      supportItems: [
        {
          tag: '组织建设',
          title: '党建工作',
          description: '党委换届、党员学习、主题参观和支部活动等图文记录。',
          route: '/lanhu_dangjiangongzuo',
          image: require('@/views/lanhu_dangjiangongzuo/assets/html/party-2016-congress.jpg')
        },
        {
          tag: '综合运行',
          title: '行政管理工作',
          description: '年度工作会议、人才招聘和博士后评审等行政管理场景。',
          route: '/lanhu_xingzhengguanligongzuo',
          image: require('@/views/lanhu_xingzhengguanligongzuo/assets/html/admin-2017-meeting.jpg')
        },
        {
          tag: '老干部服务',
          title: '离退休干部工作',
          description: '离退休人员主题党日、参观考察、慰问看望和集体活动。',
          route: '/lanhu_lituixiuganbugongzuo',
          image: require('@/views/lanhu_lituixiuganbugongzuo/assets/html/retired-2013-cuandixia.jpg')
        },
        {
          tag: '关怀活动',
          title: '集体过生日',
          description: '为离退休人员集体过生日的历史照片与说明文字。',
          route: '/lanhu_jitiguoshengri',
          image: require('@/views/lanhu_jitiguoshengri/assets/html/birthday-2016.jpg')
        },
        {
          tag: '文体活动',
          title: '职工集体活动',
          description: '职工参观、读书会、工会文体活动和集体荣誉记录。',
          route: '/lanhu_zhigongjitihuodong',
          image: require('@/views/lanhu_zhigongjitihuodong/assets/html/staff-2018-badminton.jpg')
        }
      ]
    };
  }
};
</script>

<style scoped lang="css" src="../lanhu_jigouyulishi/assets/index.css" />
<style scoped>
.section_1 {
  min-height: auto;
}

.block_3 {
  min-height: auto;
  padding-bottom: 88px;
}

.group_3 {
  padding-bottom: 36px;
}

.text_14 {
  height: auto;
}

.group_5 {
  align-items: flex-start;
}

.sidebar-slot {
  width: 274px;
  flex: 0 0 274px;
}

.sidebar-slot :deep(.sidebar-accordion) {
  width: 100%;
}

.content-slot {
  flex: 1;
  min-width: 0;
}

.content-shell {
  display: grid;
  gap: 28px;
}

.overview-card,
.entry-section {
  padding: 28px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.82), rgba(255, 255, 255, 0) 40%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(251, 249, 245, 0.98));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.entry-section {
  background:
    linear-gradient(140deg, rgba(243, 247, 250, 0.82), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(252, 250, 246, 0.95));
}

.eyebrow {
  margin: 0 0 10px;
  color: #b28a56;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.overview-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 28px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.overview-title--compact {
  font-size: 24px;
  margin-bottom: 0;
}

.overview-text {
  margin: 0 0 14px;
  color: #231f20;
  font-size: 15px;
  line-height: 1.95;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.overview-text:last-of-type {
  margin-bottom: 0;
}

.entry-section__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 22px;
}

.entry-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.entry-card {
  display: flex;
  flex-direction: column;
  min-height: 184px;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
  text-decoration: none;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.entry-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(45, 33, 16, 0.08);
  border-color: rgba(242, 92, 25, 0.22);
}

.entry-card__image {
  aspect-ratio: 16 / 9;
  background: #f6f2ec;
  overflow: hidden;
}

.entry-card__image img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.entry-card__body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 22px;
}

.entry-card__tag {
  margin: 0;
  color: #b28a56;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.12em;
}

.entry-card__title {
  margin: 0;
  color: #2c2218;
  font-size: 22px;
  line-height: 1.45;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.entry-card__desc {
  margin: 0;
  color: #5f5347;
  font-size: 14px;
  line-height: 1.8;
}

@media (max-width: 1024px) {
  .group_5 {
    flex-direction: column;
    gap: 24px;
  }

  .sidebar-slot,
  .content-slot {
    width: 100%;
    flex-basis: auto;
  }

  .entry-section__header {
    flex-direction: column;
    align-items: start;
  }
}

@media (max-width: 768px) {
  .block_3 {
    padding-bottom: 52px;
  }

  .overview-card,
  .entry-section {
    padding: 20px;
  }

  .entry-grid {
    grid-template-columns: 1fr;
  }

  .entry-card {
    min-height: auto;
  }
}
</style>
